'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentTwintAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "black",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M25.7199 34.5189C25.7199 34.8309 25.4916 35.2172 25.2177 35.3657L15.4335 40.8773C15.1596 41.0407 14.7031 41.0407 14.4292 40.8773L4.645 35.3657C4.3711 35.2023 4.14285 34.8309 4.14285 34.5189V23.4809C4.14285 23.169 4.3711 22.7827 4.645 22.6341L14.4292 17.1226C14.7031 16.9591 15.1596 16.9591 15.4335 17.1226L25.2177 22.6341C25.4916 22.7976 25.7199 23.169 25.7199 23.4809V34.5189Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M79.5707 24.0793H70.7809V26.0914H73.9244V34.728H76.412V26.0914H79.5707V24.0793Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M39.6504 24.0793H30.8606V26.0914H34.0194V34.728H36.507V26.0914H39.6504V24.0793Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M65.0888 23.7416C62.3268 23.7416 60.7855 25.4454 60.7855 27.8982V34.7281H63.2424V27.8395C63.2424 26.7673 63.8986 25.9447 65.1194 25.9447C66.3249 25.9447 66.9811 26.9141 66.9811 27.8395V34.7281H69.438V27.8982C69.438 25.4454 67.8509 23.7416 65.0888 23.7416Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M55.7958 24.0793V34.728H58.2675V24.0793H55.7958Z", fill: "white" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M47.4636 28.3094L47.555 28.7793L49.8592 34.728H50.8665L54.01 24.0793H51.5837L50.0727 29.6757L49.9966 30.2774L49.8746 29.6757L47.86 24.0793H47.0667L45.0674 29.6757L44.9454 30.2774L44.8539 29.6757L43.3583 24.0793H40.932L44.076 34.728H45.0828L47.387 28.7793L47.4636 28.3094Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M19.4763 28.7924L16.9663 32.313L15.6736 30.4239L17.1617 28.3058C17.4322 27.9337 18.0334 26.889 17.342 25.4722C16.7859 24.3273 15.5835 23.7692 14.5313 23.7692C13.4792 23.7692 12.3219 24.2844 11.7206 25.4722C11.0292 26.8318 11.6305 27.9051 11.886 28.2629C11.886 28.2629 12.7126 29.4221 13.404 30.3952L14.5313 31.9409L16.2147 34.3881C16.2298 34.4024 16.5003 34.7888 16.9663 34.7888C17.4172 34.7888 17.6877 34.4024 17.7328 34.3595L21.6858 28.7924H19.4763ZM14.5313 28.8783C14.5313 28.8783 13.87 27.9194 13.4491 27.2611C12.9832 26.5455 13.5093 25.4865 14.5313 25.4865C15.5684 25.4865 16.0795 26.5455 15.6135 27.2611C15.1927 27.9337 14.5313 28.8783 14.5313 28.8783Z",
          fill: "url(#paint0_radial_647_1970)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M12.0964 32.1982L9.61641 28.8923C9.61641 28.8923 8.95507 27.9335 8.53422 27.2751C8.06828 26.5596 8.59434 25.5005 9.61641 25.5005C9.75169 25.5005 9.87193 25.5149 9.97714 25.5435L10.8489 24.0265C10.4431 23.8691 10.0222 23.7832 9.61641 23.7832C8.56428 23.7832 7.40694 24.2984 6.80572 25.4862C6.11432 26.8458 6.71554 27.9191 6.97105 28.2769L11.2998 34.3878C11.3299 34.445 11.6155 34.8314 12.0664 34.8314C12.5323 34.8314 12.7878 34.4594 12.8329 34.4021L14.1406 32.513L13.0133 30.9388L12.0964 32.1982Z",
          fill: "url(#paint1_radial_647_1970)"
        }
      ),
      /* @__PURE__ */ jsxs("defs", { children: [
        /* @__PURE__ */ jsxs(
          "radialGradient",
          {
            id: "paint0_radial_647_1970",
            cx: 0,
            cy: 0,
            r: 1,
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(13.6991 24.6581) scale(11.6446 11.446)",
            children: [
              /* @__PURE__ */ jsx("stop", { stopColor: "#FFCC00" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.09157, stopColor: "#FFC800" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.1739, stopColor: "#FFBD00" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.2528, stopColor: "#FFAB00" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.3295, stopColor: "#FF9100" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.4046, stopColor: "#FF7000" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.4786, stopColor: "#FF4700" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.5503, stopColor: "#FF1800" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.5822, stopColor: "#FF0000" }),
              /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#FF0000" })
            ]
          }
        ),
        /* @__PURE__ */ jsxs(
          "radialGradient",
          {
            id: "paint1_radial_647_1970",
            cx: 0,
            cy: 0,
            r: 1,
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(6.67976 24.8676) scale(10.6771 10.4952)",
            children: [
              /* @__PURE__ */ jsx("stop", { stopColor: "#00B4E6" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.201, stopColor: "#00B0E3" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.3898, stopColor: "#01A5DB" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.5737, stopColor: "#0292CD" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.7546, stopColor: "#0377BA" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.9316, stopColor: "#0455A1" }),
              /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#054696" })
            ]
          }
        )
      ] })
    ]
  }
);
const VpPaymentTwintAsset = forwardRef(PaymentTwintAsset);

export { VpPaymentTwintAsset as default };
